<div class='wrapper' [style.pointer-events]='loading ? "none": "auto"'>
  <div class='label'>{{ticks[0].label}}</div>
  <button mat-icon-button (click)='prev()'>
    <mat-icon>first_page</mat-icon>
  </button>

  <div class='track-wrapper'>
    <ul #items class='items'>
      <li class='tick'
          *ngFor='let item of ticks;let i = index;'
          [matTooltip]='item.label'
          (click)='selectItem(item,i)'></li>
    </ul>
    <div class='track'>
      <div class='selection' [style.width]='selectionWidth'></div>
      <div #handle class='handle'
           (cdkDragMoved)='dragMoved($event)'
           (cdkDragEnded)='dragEnded($event)'
           [cdkDragFreeDragPosition]='dragHandlePosition'
           cdkDragLockAxis='x'
           cdkDrag
           cdkDragBoundary='.track'></div>
    </div>
  </div>

  <button mat-icon-button (click)='next()'>
    <mat-icon>last_page</mat-icon>
  </button>
  <div class='label'>{{ticks[ticks.length - 1].label}}</div>
</div>
